module.exports = __webpack_public_path__ + "media/img/about/person/ric-48f7a6123a3ef22345f98744ef4ed6f6.png";